import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { SearchStateType } from "../../../Orchestrator/Types/Index";
import { IConfirmFmlmSearchActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/ConfirmFmlmSearchActionParams";

export class ConfirmFmlmSearchAction extends BaseAction<
  void,
  IConfirmFmlmSearchActionParams
> {
  override async run(): Promise<void | null> {
    try {
      const { visible, selectedExactLocation, search, locationData, isFromPopUp } = this.params!;
      updateRecoilState("locationMapVisibleAtom", visible);
      updateRecoilState("locationDataAtom", []);
      updateRecoilState("fmlmReverseGeoCodeLocationAtom", null);
      updateRecoilState("currentLocationAtom", null);

      // set search state when user click on confirm button
      let prefix = selectedExactLocation === "origin" ? "from" : "to";
      const updatedSearchState: Partial<SearchStateType> = {
        ...search,
        [`${prefix}Name`]: locationData.name,
        [prefix]: locationData.id,
        [`${prefix}fmlmSearch`]: locationData?.locationType === "location",
        [`${prefix}GeoPosition`]: {
          latitude: locationData.coordinates[1],
          longitude: locationData.coordinates[0],
        },
      };

      if (isFromPopUp) {
        updateRecoilState("searchStatePopupAtom", updatedSearchState);
      } else {
        updateRecoilState("searchStateAtom", updatedSearchState);
      }

      if (selectedExactLocation === "origin") {
        updateRecoilState("isSelectingOriginAtom", false);
        updateRecoilState("isSelectingDestinationAtom", true);
      } else {
        updateRecoilState("isSelectingDestinationAtom", false);
      }
    } catch (error) {
      console.error("Error in OpenSubStationDropdownAction:", error);
    }
  }
}

// Create a singleton instance
export const confirmFmlmSearchAction = new ConfirmFmlmSearchAction();

